import { Card, CardContent, CardHeader, CardTitle } from "@geely/ui";
import { Clock, CheckCircle2, XCircle, CalendarDays } from 'lucide-react';

export interface Metrics {
  total: number;
  pending: number;
  completed: number;
  cancelled: number;
}

interface MetricsCardsProps {
  metrics: Metrics;
}

export function MetricsCards({ metrics }: MetricsCardsProps) {
  const cards = [
    {
      title: 'Total de Agendamentos',
      value: metrics.total,
      icon: CalendarDays,
      iconColor: 'text-blue-600',
    },
    {
      title: 'Pendentes',
      value: metrics.pending,
      icon: Clock,
      iconColor: 'text-yellow-600',
    },
    {
      title: 'Concluídos',
      value: metrics.completed,
      icon: CheckCircle2,
      iconColor: 'text-green-600',
    },
    {
      title: 'Cancelados',
      value: metrics.cancelled,
      icon: XCircle,
      iconColor: 'text-red-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-gray-600">
              {card.title}
            </CardTitle>
            <card.icon className={`size-4 ${card.iconColor}`} />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{card.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
